/**
 * Geometry and motion for the game card.
 *
 * Separate from `PromptCardBack` because a non-component export in a file of
 * components breaks fast refresh for the whole module — the same
 * `react-refresh/only-export-components` rule that moved the source helpers out
 * of `ms.tsx`.
 */

/** Card proportions match a standard landscape playing card (88.9 × 63.5mm). */
export const CARD_RATIO = "88.9 / 63.5";

/**
 * Corner radius as a share of the card, so it scales with whatever size the card
 * is drawn at — 10px on the 266px card in the hand, 13px on the 346px reveal.
 *
 * Two figures because a percentage radius resolves against width horizontally
 * and height vertically, and a landscape card would get elliptical corners from
 * a single one. These are the same physical radius stated both ways: 5.26/3.76
 * is the card's own 1.4 ratio.
 *
 * Not `cqh`. Container units are the right tool for everything *inside* the card
 * — `container-type` makes an element a container for its descendants — but an
 * element can't query itself, so a radius declared that way silently fell back
 * to the viewport and came out at 37px.
 */
export const CARD_RADIUS = "3.76% / 5.26%";

/** The spring a card rides when it grows to the fore on reveal. Shared by both
 *  prompt phases so the two modes land on the same motion. */
export const cardTransition = { type: "spring" as const, stiffness: 180, damping: 26, mass: 1.1 };
